import {
  Component,
  OnInit,
  ViewChild,
  ComponentFactoryResolver,
  Type,
  Input,
} from "@angular/core";
import { GfxMiscSrv } from "src/app/services/gfx.misc.service";
import { SharingDataService } from "src/app/services/sharing-data.service";
import { AppContentDirective } from "src/app/directives/app-content.directive";
import { GfxDynCompConfig } from "./gfx-dyn-comp-config";

@Component({
  selector: "gfx-dyn-comp",
  templateUrl: "./gfx-host.component.html",
  styleUrls: ["./gfx-host.component.css"],
})
export class GfxHostComponent implements OnInit {
  @Input("config") config : GfxDynCompConfig;
  @ViewChild(AppContentDirective, { static: true })
  appContentHost: AppContentDirective;
  title: string;

  components = [];
  gfxDynCompEvent: any;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private misc: GfxMiscSrv,
    private sharing: SharingDataService
  ) {}

  ngOnInit() {

    if(this.config) {
      this.loadDynCompContent(this.config.component);
      this.sharing.changeGfxDynConfig(this.config.data);
    }
  }

  loadDynCompContent(cName: String) {
    if (!cName) {
      return;
    }

    let components = this.components.filter((x) => x.name == cName);
    let component: Type<any> = components.length
      ? components[0].component
      : null;

    if (!component) {
      this.misc.msgDialog(
        "Alerte",
        "le composant " + cName + " n'est pas enregistré ou n'existe pas"
      );
      return;
    }

    const appDynComponentFactoryClass = this.componentFactoryResolver.resolveComponentFactory(
      component
    );
    const viewContainerRef = this.appContentHost.viewContainerRef;
 
    if (viewContainerRef) {
      viewContainerRef.clear();
    }

    let componentRef = viewContainerRef.createComponent(
      appDynComponentFactoryClass
    );
  }
}
